import * as React from "react";
import type { SVGProps } from "react";
const SvgStroller = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5 15h-2.67q-.537 0-1.063-.08l-.651 1.953A3 3 0 0 1 12 19a3 3 0 1 1-2.711-2.986l.559-1.677A7 7 0 0 1 6.18 10.21L4.78 6H3a1 1 0 0 1 0-2h2.5a1 1 0 0 1 1 .68L7.604 8H14V3a1 1 0 0 1 1-1h.5a6.5 6.5 0 0 1 6.49 6.86 1 1 0 0 1-.041.457 6.5 6.5 0 0 1-3.754 5.098l.532 1.597a3 3 0 1 1-1.83.849l-.635-1.906Q15.884 15 15.5 15m4.5-5a4.51 4.51 0 0 1-4.5 3h-2.67a5 5 0 0 1-4.539-3zm.23-2A4.51 4.51 0 0 0 16 4v4zM8.443 18.169a1 1 0 1 1 1.111 1.662 1 1 0 0 1-1.11-1.662m10 0a1 1 0 1 1 1.111 1.662 1 1 0 0 1-1.11-1.662"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStroller;
